/* import __COLOCATED_TEMPLATE__ from './new-learningmaterial.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { validatable, Custom, Length, NotBlank, IsTrue, IsURL } from 'ilios-common/decorators/validation';
import { ValidateIf } from 'class-validator';
import { TrackedAsyncData } from 'ember-async-data';
import { findBy, findById } from 'ilios-common/utils/array-helpers';
const DEFAULT_URL_VALUE = 'https://';
let NewLearningmaterialComponent = (_dec = ValidateIf(o => o.isFile), _dec2 = Custom('validateFilenameCallback', 'validateFilenameMessageCallback'), _dec3 = ValidateIf(o => o.isFile), _dec4 = NotBlank(), _dec5 = NotBlank(), _dec6 = Length(2, 80), _dec7 = NotBlank(), _dec8 = Length(4, 120), _dec9 = ValidateIf(o => o.isLink), _dec10 = NotBlank(), _dec11 = IsURL(), _dec12 = Length(1, 256), _dec13 = ValidateIf(o => o.isFile && !o.copyrightRationale), _dec14 = IsTrue(), _dec15 = ValidateIf(o => o.isFile), _dec16 = Length(2, 65000), _dec17 = ValidateIf(o => o.isCitation), _dec18 = NotBlank(), validatable(_class = (_class2 = class NewLearningmaterialComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "iliosConfig", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "filename", _descriptor5, this);
    _initializerDefineProperty(this, "fileHash", _descriptor6, this);
    _initializerDefineProperty(this, "statusId", _descriptor7, this);
    _initializerDefineProperty(this, "userRoleId", _descriptor8, this);
    _initializerDefineProperty(this, "description", _descriptor9, this);
    _initializerDefineProperty(this, "originalAuthor", _descriptor10, this);
    _initializerDefineProperty(this, "title", _descriptor11, this);
    _initializerDefineProperty(this, "link", _descriptor12, this);
    _initializerDefineProperty(this, "copyrightPermission", _descriptor13, this);
    _initializerDefineProperty(this, "copyrightRationale", _descriptor14, this);
    _initializerDefineProperty(this, "owner", _descriptor15, this);
    _initializerDefineProperty(this, "citation", _descriptor16, this);
    _initializerDefineProperty(this, "fileUploadErrorMessage", _descriptor17, this);
    _defineProperty(this, "userModel", new TrackedAsyncData(this.currentUser.getModel()));
    _defineProperty(this, "prepareSave", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.addErrorDisplayForAllFields();
        const isValid = yield this.isValid();
        if (!isValid) {
          return false;
        }
        const owningUser = yield this.currentUser.getModel();
        const learningMaterial = this.store.createRecord('learning-material', {
          title: this.title,
          status: this.selectedStatus,
          userRole: this.selectedUserRole,
          description: this.description,
          originalAuthor: this.originalAuthor,
          owningUser
        });
        switch (this.args.type) {
          case 'file':
            {
              learningMaterial.setProperties({
                copyrightRationale: this.copyrightRationale,
                copyrightPermission: this.copyrightPermission,
                filename: this.filename,
                fileHash: this.fileHash
              });
              break;
            }
          case 'link':
            {
              learningMaterial.set('link', this.link);
              break;
            }
          case 'citation':
            {
              learningMaterial.set('citation', this.citation);
              break;
            }
        }
        yield this.args.save(learningMaterial);
        this.clearErrorDisplay();
      }
    }), null, "prepareSave", "drop"));
  }
  get hasErrorForCopyrightPermissionData() {
    return new TrackedAsyncData(this.hasErrorFor('copyrightPermission'));
  }
  get hasErrorForCopyrightPermission() {
    return this.hasErrorForCopyrightPermissionData.isResolved ? this.hasErrorForCopyrightPermissionData.value : false;
  }
  get currentUserModel() {
    return this.userModel.isResolved ? this.userModel.value : null;
  }
  get isFile() {
    return this.args.type === 'file';
  }
  get isCitation() {
    return this.args.type === 'citation';
  }
  get isLink() {
    return this.args.type === 'link';
  }
  get selectedStatus() {
    if (!this.args.learningMaterialStatuses) {
      return null;
    }
    if (this.statusId) {
      return findById(this.args.learningMaterialStatuses, this.statusId);
    }
    return findBy(this.args.learningMaterialStatuses, 'title', 'Final');
  }
  get selectedUserRole() {
    if (!this.args.learningMaterialUserRoles) {
      return null;
    }
    if (this.userRoleId) {
      return findById(this.args.learningMaterialUserRoles, this.userRoleId);
    }
    return this.args.learningMaterialUserRoles[0];
  }
  get bestLink() {
    return this.link ?? DEFAULT_URL_VALUE;
  }
  changeStatusId(event) {
    this.statusId = event.target.value;
  }
  changeUserRoleId(event) {
    this.userRoleId = event.target.value;
  }
  changeLink(value) {
    value = value.trim();
    const regex = RegExp('https://http[s]?:');
    if (regex.test(value)) {
      value = value.substring(8);
    }
    this.link = value;
  }
  selectAllText({
    target
  }) {
    if (target.value === DEFAULT_URL_VALUE) {
      target.select();
    }
  }
  validateFilenameCallback() {
    if (typeof this.filename === 'string') {
      return this.filename.trim() !== '';
    }
    return this.filename !== null && this.filename !== undefined;
  }
  validateFilenameMessageCallback() {
    return this.intl.t('errors.missingFile');
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "iliosConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "filename", [_dec, _dec2, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "fileHash", [_dec3, _dec4, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "statusId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "userRoleId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "description", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "originalAuthor", [_dec5, _dec6, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec7, _dec8, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "link", [_dec9, _dec10, _dec11, _dec12, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return DEFAULT_URL_VALUE;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "copyrightPermission", [_dec13, _dec14, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "copyrightRationale", [_dec15, _dec16, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "owner", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "citation", [_dec17, _dec18, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "fileUploadErrorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "hasErrorForCopyrightPermissionData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "hasErrorForCopyrightPermissionData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentUserModel", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "currentUserModel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeStatusId", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeStatusId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeUserRoleId", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeUserRoleId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeLink", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeLink"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectAllText", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "selectAllText"), _class2.prototype), _class2)) || _class);
export { NewLearningmaterialComponent as default };